export default __webpack_public_path__ + "static/WorkSans-SemiBold-efd03efacdd29f168d270188b26766b4.woff";